// Re-renders additional fragments when a field changes, in addition to the field's own form group.
//
// Unpoly's [up-validate] on a field *replaces* the default validation target (the field's own form group)
// with the given selector. Validation errors that were rendered into the field's form group would then never
// be cleared by changing the field itself. Use [validate-also] instead when a field change should also
// refresh dependent fragments:
//
//   = simple_form_for training, html: { 'up-validate': true } do |form|
//     = form.input :training_ground_id, input_html: { 'validate-also': '.program-id-field' }
//
// The form needs [up-validate], so that every field validates its own form group.
// Unpoly batches both validations into a single request.
up.compiler('[validate-also]', (field) => {
  const target = field.getAttribute('validate-also')

  return up.on(field, 'change', () => {
    up.validate(field, { target })
  })
})
